import Vue from 'vue';

export default {
    async index(params) {
        const filter = params ? Object.keys(params).map((key) => `${key}=${params[key]}`).join('&') : '';
        const response = await Vue.axios.get('/api/v1/eligibilities?' + filter);
        return response.data;
    },
}
